import React from 'react';
import { isEmpty } from 'lodash';
import Menu, { SubMenu, MenuItem } from 'rc-menu';
import '../../../node_modules/rc-menu/assets/index.css';
import { NavLink } from 'react-router-dom';
import c from '../../config';
import { isExternalURL, parseSanitizedHTML } from '../../utils/Helper';

const MobileMenu = (props) => {
  const { menu, setIsOpen } = props;

  const onOpenChange = (value) => {
    console.log('onOpenChange', value);
    const subMenus = document.querySelectorAll(
      '.rc-menu-submenu-open:not(.rc-menu-submenu-active)',
    );
    for (let i = 0; subMenus.length > i; i++) {
      subMenus[i].querySelector('.rc-menu-submenu-title').click();
    }
  };

  const generateMenu = (items = []) => {
    const menuItems = [];
    if (items.length > 0) {
      items.map((item, i) => {
        if (item.menu_level_2) {
          menuItems.push(
            <SubMenu key={i} title={parseSanitizedHTML(item.title)}>
              {generateDropDownMenu(item, i)}
            </SubMenu>,
          );
        } else if (isExternalURL(item.url)) {
          menuItems.push(
            <MenuItem key={i}>
              <a
                href={item.url}
                className="nav-link nav-item"
                target="_blank"
                rel="noopener noreferrer"
              >
                {parseSanitizedHTML(item.title)}
              </a>
            </MenuItem>,
          );
        } else {
          menuItems.push(
            <MenuItem key={i}>
              <NavLink
                to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
                className="nav-link nav-item"
                activeClassName="active"
                onClick={() => setIsOpen(false)}
              >
                {parseSanitizedHTML(item.title)}
              </NavLink>
            </MenuItem>,
          );
        }
        return '';
      });
    }
    return menuItems;
  };

  // Level 2
  const generateDropDownMenu = (item, i) => {
    const result = [];
    let url = '';
    if (isExternalURL(item.url)) {
      url = (
        <a href={item.url} className="nav-link" target="_blank" rel="noopener noreferrer">
          {parseSanitizedHTML(item.title)}
        </a>
      );
    } else if (item.url) {
      url = (
        <NavLink
          to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
          className="nav-link"
          activeClassName="active"
          onClick={() => setIsOpen(false)}
        >
          {parseSanitizedHTML(item.title)}
        </NavLink>
      );
    } else {
      url = (
        <span className="nav-link active" target="_blank" rel="noopener noreferrer">
          {parseSanitizedHTML(item.title)}
        </span>
      );
    }
    // result.push(<MenuItem>{url}</MenuItem>);
    result.push(generateMenuItems(item.menu_level_2));
    return result;
  };

  const generateMenuItems = (items = []) => {
    const url = [];
    let newItems = [];
    if (typeof items !== 'undefined' && items instanceof Array) {
      newItems = items;
    } else {
      newItems.push(items);
    }
    if (newItems.length > 0) {
      newItems.map((item, i) => {
        if (isExternalURL(item.url)) {
          url.push(
            <MenuItem>
              <a
                key={i}
                href={item.url}
                className="nav-link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {parseSanitizedHTML(item.title)}
              </a>
            </MenuItem>,
          );
        } else {
          url.push(
            <MenuItem>
              <NavLink
                key={i}
                to={(location) => ({ ...location, pathname: c.routePathTo + item.url })}
                className="nav-link"
                activeClassName="active"
                onClick={() => setIsOpen(false)}
              >
                {parseSanitizedHTML(item.title)}
              </NavLink>
            </MenuItem>,
          );
        }
        return '';
      });
    }
    return url;
  };

  let menuDropdown;

  if (!isEmpty(menu)) {
    menuDropdown = generateMenu(menu.menu_level_1);
  }

  return (
    <div>
      <Menu
        mode="inline"
        className="ct-mobileMenu"
        openAnimation="slide-up"
        triggerSubMenuAction="click"
        onOpenChange={onOpenChange}
      >
        {menuDropdown}
      </Menu>
    </div>
  );
};

export default MobileMenu;
